// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"ca065178","938":"28f767cb"}[chunkId] + ".chunk.css";
};